import { useAiRestoredShotUrls } from '@/composables/ai-upload/useAiRestoredShotUrls';
import type { AppPageProps } from '@/types';
import type { ConfigurableProductPageObject } from '@/types/product';
import { usePage } from '@inertiajs/vue3';
import { watch } from 'vue';

type AiGalleryRestorePageProps = AppPageProps & {
    product: ConfigurableProductPageObject;
};

// Key is per product only, and must match the Blade-side derivation in ai-paint-restore.blade.php.
export function aiGalleryRestoreKey(sku: string): string {
    return `ai-gallery-restore-${sku}`;
}

// Keeps a caption → shot URL map in sessionStorage for the pre-paint restore script; the cached page HTML shows stock artwork until Vue hydrates.
export function useAiGalleryRestoreSnapshot(): void {
    if (typeof window === 'undefined') {
        return;
    }

    const page = usePage<AiGalleryRestorePageProps>();
    const { restoredByCaption } = useAiRestoredShotUrls();
    const key = aiGalleryRestoreKey(page.props.product.group_identifier);

    watch(
        restoredByCaption,
        (byCaption: Map<string, string>) => {
            if (byCaption.size === 0) {
                sessionStorage.removeItem(key);
                return;
            }

            sessionStorage.setItem(key, JSON.stringify(Object.fromEntries(byCaption)));
        },
        { immediate: true },
    );
}
